module.exports = __webpack_public_path__ + "static/media/stars.67927a75.png";